"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var Constants = _interopRequireWildcard(require("./constants"));

var _ref;

var _default = new _immutable.Record((_ref = {}, (0, _defineProperty2.default)(_ref, Constants.ID, null), (0, _defineProperty2.default)(_ref, Constants.USER_ID, null), (0, _defineProperty2.default)(_ref, Constants.KEY, null), (0, _defineProperty2.default)(_ref, Constants.VALUE, null), (0, _defineProperty2.default)(_ref, Constants.EMAIL, null), _ref), Constants.USER_APP_ATTRIBUTE);

exports.default = _default;
module.exports = exports.default;